'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$23() {
  this.b5A = null;
  this.b5B = false;
}
export { $c_Lpresto_LoginPageView$$anon$23 as $c_Lpresto_LoginPageView$$anon$23 };
$p = $c_Lpresto_LoginPageView$$anon$23.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$23;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$23() {
}
export { $h_Lpresto_LoginPageView$$anon$23 as $h_Lpresto_LoginPageView$$anon$23 };
$h_Lpresto_LoginPageView$$anon$23.prototype = $p;
$p.P = (function() {
  if ((!this.b5B)) {
    this.b5A = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.b5B = true;
  }
  return this.b5A;
});
var $d_Lpresto_LoginPageView$$anon$23 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$23, "presto.LoginPageView$$anon$23", ({
  Mo: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$23 as $d_Lpresto_LoginPageView$$anon$23 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$23.js.map
